import { red } from "@mui/material/colors";

const styles = {
  container: {
    maxWidth: "400px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 12,
    justifyContent: "center",
    alignItems: "center",
  },
  textfield: {
    width: "300px",
    marginTop: "12px",
  },
  form: {
    width: "300px",
  },
  alert: {
    width: "270px",
  },
  button: {
    width: "300px",
    borderRadius: "0.5rem",
    backgroundColor: red["A400"],
  },
  circularProgress: {
    color: "white",
  }
};

export default styles;
